import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAppSelector } from "../store";
import { unfulfilledConditionPage } from "../components/GeneralUI/Message/unfulfilledConditionPage";

export const NoSites = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pageName = location.pathname.split("/")[1];
  const sites = useAppSelector((state) => state.sites.sites);
  const companyId = useAppSelector((state) => state.company.company?.id);
  const siteId = useAppSelector((state) => state.site?.id);

  useEffect(() => {
    if (!companyId || !siteId) return;
    if (sites && sites.length > 0) {
      navigate(`/company/${companyId}/site/${siteId}/${pageName}`);
    }
  }, [sites, companyId, siteId]);

  return unfulfilledConditionPage("connect the site first", pageName);
};
